import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../contexts/AuthContext';

/**
 * useAuth Hook
 *
 * 用於訪問認證上下文的自定義 Hook
 *
 * @throws {Error} 如果在 AuthProvider 外使用
 * @returns {AuthContextType} 認證上下文
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { isAuthenticated, user, login, logout } = useAuth();
 *
 *   if (!isAuthenticated) {
 *     return <LoginForm onLogin={login} />;
 *   }
 *
 *   return (
 *     <div>
 *       <h1>歡迎, {user?.full_name}</h1>
 *       <button onClick={logout}>登出</button>
 *     </div>
 *   );
 * }
 * ```
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth 必須在 AuthProvider 內使用');
  }

  return context;
};

export default useAuth;
